import React, { useContext } from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory } from "react-router-dom";
import { useEditMode } from "../customHooks/useEditMode";
import { tooltips } from "../popData";

const Footer = ({
  children,
  title,
  back = false,
  // menu = false,
  backlink = "",
  warning = false,
}) => {
  const history = useHistory();
  const { resetEditMode } = useEditMode();
  // const location = useLocation();
  // const [backTo, setBackTo] = useState("");

  // console.log("history", history);

  function goBack() {
    // if (backTo) {
    //   history.push(backTo);
    // }

    resetEditMode();

    if (backlink) {
      history.push(backlink);
    } else {
      history.goBack();
    }
  }

  return (
    <footer className="footerBar">
      <div className="backBox">
        {back && (
          <button title={tooltips.goBack} onClick={goBack}>
            <ArrowBackIcon style={{ fontSize: 25 }} />
          </button>
        )}
      </div>
      <span className="title">{title}</span>

      <div className="pageSpecificOptions">
        {back && (
          <button title={tooltips.goBack} className="adder go-back" onClick={goBack}>
            <ArrowBackIcon style={{ fontSize: 25 }} />
          </button>
        )}
        {children}
      </div>
    </footer>
  );
};

export default React.memo(Footer);
